import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import { fetchVehicle } from '../../../services/vehicles';

const getVehicle = (
  options: {
    locale: string;
    vehicle: string;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchVehicle>
] => [
  ['vehicle', { locale: options.locale, slug: options.vehicle }],
  ({
    queryKey: [, key],
  }: {
    queryKey: [string, { locale: string; slug: string }];
  }) => fetchVehicle(key, req),
];

export default getVehicle;
